<template>
  <div class="modalDetails">
    <div>
      <div style="padding:20px;">
        <p>
          {{ $t("popup.colorChart") }}:
          <span class="titre"
            >{{ $t(significationCouleur.color[key].titre) }}{{ " " }}</span
          >
          <button
            :style="significationCouleur.color[key].background"
            class="button is-rounded"
          >
            {{ " " }}
          </button>
        </p>
        <div style="width:100%;overflow-x:hidden;max-height:400px; overflow-y:auto;">
          <h2 class="titre has-text-centered mt-3">
            {{ $t("significationColor.travaille") }}
          </h2>
          <!-- premier tableau -->
          <b-table
            :striped="true"
            :hoverable="true"
            :data="significationCouleur.color[key].TravaillerAvec"
          >
            <template>
              <b-table-column v-slot="props" :label="$t('popup.theme')">
                <p :style="significationCouleur.color[key].color">
                  {{ $t(props.row.theme) }}
                </p>
              </b-table-column>

              <b-table-column v-slot="props" :label="$t('popup.todo')">{{
                $t(props.row.Afaire)
              }}</b-table-column>

              <b-table-column v-slot="props" :label="$t('popup.notTodo')">{{
                $t(props.row.AEviter)
              }}</b-table-column>
            </template>
          </b-table>
          <!-- deuxième tableau -->
          <h2 class="titre has-text-centered mt-3">
            {{ $t("significationColor.stress") }}
          </h2>
          <div class="columns">
            <div
              class="column mt-2"
              v-for="(el, index) in significationCouleur.color[key].SonStress"
              :key="el.id"
            >
              <div class="card">
                <div class="card-content">
                  <h2
                    :style="significationCouleur.color[key].color"
                    class="has-text-weight-semibold"
                  >
                    {{
                      $t(significationCouleur.color[key].SonStress[index].titre)
                    }}
                  </h2>
                  <div
                    class="mt-3"
                    v-for="el in significationCouleur.color[key].SonStress[
                      index
                    ].list"
                    :key="el.id"
                  >
                    <p>{{ $t(el) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import significationCouleur from "../../data/significationCouleur";

export default {
  props: ["id"],
  data() {
    return {
      key: this.id,
      significationCouleur: significationCouleur,
    };
  },
};
</script>

<style scoped>
.background {
  background-color: white;
}
.titre {
  font-size: 1.5em;
}
.fiche {
  border: 1px rgb(223, 223, 223) solid;
  border-radius: 0.7em;
}
.modalDetails {
  background-color: white;
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px 20px;
}
</style>
